import React from "react";
import {LoadWebsiteDetailsEpic} from '../../actions/website.actions';
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import AddMenuItem from './AddMenuItem';
import MenuItemDetails from './MenuItemDetails';
import GroupDetails from './GroupDetails';
import MenuDetails from './MenuDetails';

import {
  Route,
  Switch,
} from 'react-router-dom';
export class WebsiteHome extends React.Component {

  componentDidMount() {
    this.props.loadWebsiteDetails(this.props.companyId);
  }

  render() {
    

    return (
      <div>
        <Switch>
          <Route path="/websites/:websiteId/menu/:menuId/group/:groupId/items/add" component={AddMenuItem}/>
          <Route path="/websites/:websiteId/menu/:menuId/group/:groupId/item/:menuItemId" component={MenuItemDetails}/>
          <Route path="/websites/:websiteId/menu/:menuId/group/:groupId" component={GroupDetails}/>
          <Route path="/websites/:websiteId/menu/:menuId" component={MenuDetails}/>
        </Switch>
      </div>
    );
  }
}

let mapStateToProps = ({websiteEndpoint, nav, authEndpoint},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError? true:false,
  website: websiteEndpoint.website,
  companyId: nav.selectedCompany? nav.selectedCompany : authEndpoint.companyId,
  url: match.url
})

let mapDispatchToProps = (dispatch) => ({
  loadWebsiteDetails : (companyId) => dispatch(LoadWebsiteDetailsEpic(companyId)),
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(WebsiteHome));





// WEBPACK FOOTER //
// ./src/containers/Menu/MenuHome.js